<template>
    <div v-if="expandedResults[parentAcademyId]">
        <div v-for="mergedResult in parentResultsMap[parentAcademyId]" :key="mergedResult.academyId">
            <MergedAcademyMedals :merged-result="mergedResult" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import MergedAcademyMedals from "./MergedAcademyMedals.vue";
    import { ParentResultsMap } from "../Api/competitorResultsApi";
    import { useAcademyResultsStore } from "./academyResultsStore";

    defineProps<{
        parentAcademyId: number;
    }>();

    const store2 = useAcademyResultsStore();

    const expandedResults = computed(() => store2.expandedResults);
    const parentResultsMap = computed<ParentResultsMap>(() => store2.parentResultsMap);
</script>

<style scoped></style>
